import { render } from "./YellowRegistrationStepOne.vue?vue&type=template&id=28ba3a14"
import script from "./YellowRegistrationStepOne.vue?vue&type=script&lang=js"
export * from "./YellowRegistrationStepOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__